import { useMutation } from '@apollo/client/react';
import { Result, Spin } from 'antd';
import React, { useEffect } from 'react';
import { ROUTES } from '../../common/constants';
import useRouter from '../../common/useRouter';
import { VERIFY_EMAIL, VERIFY_PHONE_NO } from './graphql/Mutation';

const VerifyDetails = () => {
  const { navigate, location } = useRouter();

  const getQuery = () => {
    return new URLSearchParams(location?.search);
  };
  const userId = getQuery().get('uid');
  const verificationToken = getQuery().get('token');
  const type = getQuery().get('type');

  const [verifyEmail] = useMutation(VERIFY_EMAIL, {
    onError() {
      navigate(ROUTES.LOGIN);
    },
    onCompleted() {
      navigate(ROUTES.LOGIN);
    },
  });
  const [verifyPhoneNo] = useMutation(VERIFY_PHONE_NO, {
    onError() {
      navigate(ROUTES.LOGIN);
    },
    onCompleted() {
      navigate(ROUTES.LOGIN);
    },
  });

  useEffect(() => {
    if (type === 'email') {
      verifyEmail({ variables: { where: { userId, verificationToken } } });
    } else if (type === 'phone') {
      verifyPhoneNo({
        variables: {
          where: { userId, numberVerificationToken: verificationToken },
        },
      });
    }
  }, [type]);

  return (
    <>
      <div id="verify-details-wrapper" className="mobile-card-wrapper">
        <Result
          id="verify-details-result"
          className="verify-details-result"
          icon={<Spin id="verify-details-spinner" size="large" spinning />}
          title="We are verifying your details"
        />
      </div>
    </>
  );
};

export default VerifyDetails;
